<div class="my-latest-sites-component">
    <h2 i18n="my latest sites title@@my-latest-sites-title" class="widget-header h4">Recently visited collaboration sites</h2>

    <h3 class="text-muted h6" i18n="my latest sites sub title@@my-latest-sites-sub-title">You have recently visited these collaboration sites.</h3>

    <div class="my-latest-sites-container">
        <div *ngIf="myLatestSites$ | async as sites" class="row">
            <div *ngFor="let site of sites" class="col-12 col-md-6 col-lg-4 col-xxl-2 mt-4" (mouseenter)="whenMouseEnter(site)">
                <div class="card border-0">
                    <div tabindex="0" class="card-inner-container" (touchstart)="whenTouched($event, site)" (focus)="whenTouched($event, site)" (blur)="removeTouched($event, site)">
                        <div class="card-body front d-flex justify-content-center align-items-center" [style.background-color]="site.resourceVisualization.color">
                            <div class="inner-body">
                                <div class="h1 letters-text text-uppercase bolder m-0">
                                    {{ getGroupLetters(site.title) }}
                                    <div class="card-link mt-2">{{site.title}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body back d-flex justify-content-center align-items-center">
                            <ng-container *ngIf="site.Hovered && site.EndPoints$ | async as items">
                                <div class="col" *ngIf="items && items.length > 0 && items[0].providerName === 'Microsoft Teams'">
                                    <a href="{{items[0].uri}}" i18n-title="@@redirect-to-teams" title="Redirect to Teams">
                                        <i aria-hidden="true" class="ms-Icon ms-BrandIcon--icon48 ms-BrandIcon--teams"></i>
                                        <span class="sr-only" i18n="@@redirect-to-teams">Redirect to Teams</span>
                                    </a>
                                </div>
                                <div class="col" *ngIf="items && items.length > 0 && items[0].providerName === 'Yammer'">
                                    <a href="{{items[0].uri}}" i18n-title="@@redirect-to-yammer" title="Redirect to Yammer">
                                        <i aria-hidden="true" class="ms-Icon ms-Icon--YammerLogo font-size-40"></i>
                                        <span class="sr-only" i18n="@@redirect-to-yammer">Redirect to Yammer</span>
                                    </a>
                                </div>
                                <div class="col" *ngIf="items">
                                    <a href="{{site.Url}}/_layouts/groupstatus.aspx?id={{site.groupId}}&target=SITE" i18n-title="@@redirect-to-sp" title="Redirect to SharePoint">
                                        <i aria-hidden="true" class="ms-Icon ms-BrandIcon--icon48 ms-BrandIcon--sharepoint"></i>
                                        <span class="sr-only" i18n="@@redirect-to-sp">Redirect to SharePoint</span>
                                    </a>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="(endPointsErrorSubject$ | async)?.groupId === site.groupId">
                                <div class="col">
                                    <span i18n="my latest sites deleted@@my-latest-sites-deleted">
                                        This group has recently been deleted. It will disappear from here when the search index has been updated.
                                    </span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="sites.length === 0">
                <app-text-placeholder>
                    <p i18n="no latest sites@@no-latest-sites">No recent visited sites were found.</p>
                </app-text-placeholder>
            </div>

        </div>
        <div *ngIf="loading" class="mt-4">
            <div *ngIf="errorSubject$ | async as err; else innerLoading">
                <app-error-templates [error]="err.status" [componentName]="componentName"></app-error-templates>
            </div>
            <ng-template #innerLoading>
                <app-widget-placeholder></app-widget-placeholder>
            </ng-template>
        </div>
    </div>

</div>
